
<template>
  <v-card class="chat-room">
    <v-toolbar card dense flat class="white chat-room--toolbar" light>

            <template>
        <!-- Top level -->
      
        <v-list-tile href="#/chat/contact" class="py-2 mini-tile my-2" avatar>
          <v-icon color="blue" class="v-icon mini-icon material-icons" size="36">contacts</v-icon>
        </v-list-tile>
           <v-list-tile href="#/chat/friend" class="py-2 mini-tile my-2" avatar>
          <v-icon color="blue" class="v-icon mini-icon material-icons" size="36">person_pin</v-icon>
        </v-list-tile>
      </template>
    </v-toolbar>    
    <vue-perfect-scrollbar class="chat-room--scrollbar grey lighten-5" v-bind:style="computeHeight">
      <v-card-text class="chat-room--list pa-3">
       
        <template v-for="(message, index) in chat.messages">
       
          <div v-bind:class="[ message.from_id != createdById ? '' : 'reverse']" class="messaging-item layout row my-4" v-bind:key="index">
            <v-avatar class="indigo mx-1" size="40">
            <!--   <img v-bind:src="getAvatar(message.participant_ids)" v-if="getAvatar(message.participant_ids) != null" alt=""> -->
              <span class="white--text headline">{{ firstLetter(message.from_username)}}  </span>
              
            </v-avatar>
            <div class="messaging--body layout column mx-2">
              
              <p :value="true" v-bind:class="[  message.from_id != createdById ? 'white' : 'success white--text']" class="pa-2" v-if="message.data_type=='primaryText'" >
                {{message.text}}
              </p>

              <p :value="true" v-bind:class="[   message.from_id != createdById ? 'white' : 'success white--text']" class="pa-2 images clearfix" v-else-if="message.data_type=='image'" v-viewer>
          
              <template >
                <img :src="[message.image]" class="image">
              </template>
          
              </p>

              <p :value="true" v-bind:class="[  message.from_id != createdById ? 'white' : 'success white--text']" class="pa-2" v-else-if="message.data_type=='audio'">
                     
                <button class="btn btn-primary btn-sm" @click.prevent="playSound(message.audio)"><span class="fa fa-play-circle-o"></span></button>
              </p>
              <div class="caption px-2 text--secondary">{{new Date(message.created_at).toLocaleString()}}</div>
            </div>
            <v-spacer></v-spacer>
          </div>
        </template>
      </v-card-text>  
    </vue-perfect-scrollbar>


  <v-container fluid>
<v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
					<img :src="imageUrl" height="150" v-if="imageUrl"/>
			<!-- 		<v-text-field label="Select Image" @click='pickFile' v-model='imageName' ></v-text-field> -->
					<input
						type="file"
						style="display: none"
						ref="image"
						accept="image/*"
						@change="onFilePicked"
					>
				</v-flex>
         <input type="text" 
        class="styled-input"
        v-model="send_text"
        placeholder="Type some message here"
        v-on:keyup.enter="sendMessage('primaryText')"
        >
        <button @click="sendMessage('primaryText')"><v-icon slot="append-icon" class="mx-2">{{'chat._Send_btn_'|translate}}</v-icon></button> 
        <button @click="pickFile"><v-icon slot="append-icon" class="mx-2">photo</v-icon></button> 
      
			</v-container>

        
  

  </v-card>

</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { db } from '@/api/firebaseInit';
import { storage } from '@/api/firebaseInit';
import firebase from 'firebase';

export default {
  components: {
    VuePerfectScrollbar,

  },
  props: {
    uuid: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: null,
    }
  },
    data: function () {
    return {
      images:[],
      imageName: '',
	  	imageUrl: '',
	  	imageFile: '',
      from_id: '',
      reverse_class:false,
        createdById:'',
       createdBy:'',
       send_text:'',
     message_info :{ 
       from_id:'',
       from_username:'',
       conversation_id:'',
       participants:[]
     }
    }
  },
  computed: {

    chat () {
          let messages = this.$store.getters.messages;
         let convos = this.$store.getters.convos;
          let groups = this.$store.getters.groups;
         var convos_s=[];
       //  console.log('groups '+JSON.stringify(groups))
    if(this.$route.params.new_convos) {

             //  console.log(" new ")
                  messages = messages.filter(item => (item.conversation_id) === this.$route.params.uuid);     
              for(var i =0;i<convos.length;i++){
                if(convos[i].uuid ==this.$route.params.uuid)
                convos_s = convos[i].participants;
              } 


              this.message_info.from_id= this.createdById,
              this.message_info.from_username=this.createdBy;
              this.message_info.conversation_id =this.$route.params.uuid ;
              this.message_info.participants = convos_s;


                    let chatOrigin = {
                      title: 'Chat',
                      users:convos_s,
                      messages: messages
                    };
                  
                    return chatOrigin;

      } else {
   
            //  console.log(" not neww")
          
              if(messages.length>0) { 
            
                for(var i =0;i<convos.length;i++){
                  if(convos[i].uuid ==this.$route.params.uuid)
                  convos_s = convos[i].participants;
                }
            
                }
              
                messages = messages.filter(item => (item.conversation_id) === this.$route.params.uuid);
              
              if(messages.length>0) {
              
                this.message_info.from_id= this.createdById,
                this.message_info.from_username=this.createdBy;
                this.message_info.conversation_id  = this.$route.params.uuid;
                this.message_info.participants = messages[0].hasOwnProperty('participants') ? messages[0].participants :messages[1].participants;
            
                }
                let chatOrigin = {
                  title: 'Chat',
                  users:convos_s,
                  messages: messages
                };
              
                return chatOrigin;
      }
    },
    computeHeight () {
      return {
        height: this.height || ''
      };
    }
  },

  created() {
   
          if(firebase.auth().currentUser) {
        this.createdById = firebase.auth().currentUser.uid
        this.createdBy = firebase.auth().currentUser.displayName
        if(!this.createdBy) {
          this.createdBy = firebase.auth().currentUser.email
        }
      }
  },
methods: {

  relaod_conversation() {
      let messages = this.$store.getters.messages;
      messages = messages.filter(item => (item.conversation_id) === this.$route.params.uuid);
       this.$store.dispatch('fetchMessages')
 
  },
		  pickFile () {
            this.$refs.image.click ()
        },

               saveImageUrl (url) {
         this.images.push(url)
         console.log("url image "+JSON.stringify(this.images))
         this.sendMessage('image')
        },



    	onFilePicked (e) {
      
      var that = this
      
    
      var files = e.target.files
      var blob="";
      var name ="";
      var images_s= [];
       that.images=[];     
      var imageFile = e.target.files[0];
      
        if(imageFile !== undefined) {
      		this.imageName = files[0].name
   
		 		const fr = new FileReader ()
				fr.readAsDataURL(imageFile)
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result
          this.imageFile = imageFile // this is an image file that can be sent to server...
          
        }) 
          blob = new Blob([imageFile], { type: imageFile.type });
       
          const pictRef = storage
        .ref()
        .child(
         `media_attachements/${this.createdById}/chat/images/${new Date().getTime()}`
        );
      pictRef.put(blob).then(function(snapshot) {
        pictRef
          .getDownloadURL()
          .then(url => {
          that.saveImageUrl(url)
             url=''
             blob=''
             name='' 
        })
        
          .catch(function(error) {
            alert(`error--${error}`);
          });
      });
       
			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = ''
			}
    
		},


    
 sendMessage(data_type) {

      const MessageRef = db.collection("Messages").doc();
      const refKey = MessageRef.id;
      this.message_id = refKey;

        var message = {
                id: this.message_id,
                entitykey:this.message_id,
                from_id: this.createdById,
                conversation_id:  this.message_info.conversation_id,
                from_username:  this.createdBy,
                participants_ids:  this.message_info.participants,
                sender:true,
                priority:1,
                timestamp: new Date(),
        }

            if(data_type=='image') {
              message.viewType=6,  
              message.type='image'
              message.urls= this.images
            } else if(data_type=='primaryText') {
           
                  message.viewType=2,  
                  message.type='primaryText'
                  message.text= this.send_text
            }


       // console.log("stocked "+JSON.stringify(message))
      MessageRef
        .set(message)
        .then(() => {
            this.send_text=''
          	this.imageName = ''
				    this.imageFile = ''
				    this.imageUrl = ''
            this.$store.dispatch('fetchMessages')
        
        })
        .catch(error => {
          console.error("Error adding message: ", error);
        });

    },

        playSound (sound) {
      if(sound) {
        console.log('here'+sound)
        var audio = new Audio(sound);
        audio.play();
      }
    },
    click() {
      alert("nn");
    },
        firstLetter(name) {
          var fl = name.split(' ')[1].charAt(0) 
      return name.charAt(0)+fl;
    },
    getAvatar (uuid) {
      let user = this.$store.getters.getUserById(uuid);
      return user.avatar;
    }
  }  
};
</script>

<style lang="scss" scoped>


.image {
  height: 100px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

input[type=text] {
  width: 90%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}


input[type=submit]:hover {
  background-color: #45a049;
}

/* div {
  border-radius: 5px;
  background-color: #f2f2f2;
  padding: 20px;
} */
</style>





// WEBPACK FOOTER //
// src/components/chat/ChatWindow.vue